import React from "react";

/**
 * Avatar - User avatar component
 * @param {object} props Component props
 * @param {string} props.alt Alt text for the image
 * @param {string} props.src Image source URL
 * @param {string} props.className Additional CSS classes
 * @author Forge
 * @date 2026-04-02
 * @version 1.0
 */
export default function Avatar({ alt, src, className = "" }) {
  return (
    <img
      src={src}
      alt={alt}
      className={`topbar-avatar ${className}`}
    />
  );
}
